<template>
  <context-bar-and-content class="w2-generator">
    <template slot="context-bar-left">
      <strong v-if="!paystubs.length">PAYSTUB TO W2 GENERATOR</strong>
      <el-button icon="el-icon-arrow-left" @click="startOver" v-else>Start Over</el-button>
    </template>
    <template slot="context-bar-right">
      &nbsp;
    </template>
    <div class="main-section">
      <el-row>
        <el-col :span="18" :offset="3" class="mb-3">
          <h4 class="text-uppercased">Paystubs <el-button type="primary" icon="plus" @click="addPaystub">Add Paystub</el-button></h4>
          <paystub-table :paystubs="paystubs" @edit="editPaystub" @remove="removePaystub"></paystub-table>
        </el-col>
        <el-col :span="18" :offset="3" class="align-center">
          <el-button size="large" type="primary" icon="fa fa-gears" @click="generateW2s" :disabled="paystubs.length === 0">Generate W2s</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="Edit Paystub"
      :visible.sync="editPaystubDialogVm.visible"
      width="600px">
      <edit-paystub-dialog :paystub="editPaystubDialogVm.paystub" @paystubAdded="onPaystubAdded" @close="closeEditPaystubDialog" keep-local />
    </el-dialog>
    <el-dialog
      title="Generate W2"
      :visible.sync="generateW2DialogVm.visible"
      width="400px">
      <generate-w2-dialog ref="generateW2Dialog" :paystubs="paystubs" :client="generateW2DialogVm.client" @close="closeGenerateW2Dialog" />
    </el-dialog>
  </context-bar-and-content>
</template>

<script>
import without from 'lodash/without';
import uniqueId from 'lodash/uniqueId';
import findIndex from 'lodash/findIndex';
import ContextBarAndContent from '@/components/layout/ContextBarAndContent.vue';
import PaystubTable from '@/components/tables/Paystub.vue';
import EditPaystubDialog from '@/components/dialog-content/EditPaystub.vue';
import GenerateW2Dialog from '@/components/dialog-content/GenerateW2.vue';

export default {
  name: 'w2-generator',
  data() {
    return {
      paystubs: [],
      editPaystubDialogVm: {
        visible: false,
        paystub: null,
      },
      generateW2DialogVm: {
        visible: false,
        client: null,
      },
    };
  },
  methods: {
    startOver() {
      this.paystubs = [];
      this.editPaystubDialogVm.visible = false;
      this.editPaystubDialogVm.paystub = null;
      this.generateW2DialogVm.visible = false;
      this.generateW2DialogVm.client = null;
      this.$refs.generateW2Dialog.resetForm();
    },
    addPaystub() {
      this.editPaystubDialogVm.paystub = null;
      this.editPaystubDialogVm.visible = true;
    },
    editPaystub(paystub) {
      this.editPaystubDialogVm.paystub = paystub;
      this.editPaystubDialogVm.visible = true;
    },
    removePaystub(paystub) {
      this.paystubs = without(this.paystubs, paystub);
    },
    onPaystubAdded(paystub) {
      if (!paystub._entityId) {
        paystub._entityId = uniqueId('paystub_');
        this.paystubs.push(paystub);
      } else {
        const clone = [...this.paystubs];
        clone[findIndex(this.paystubs, ['_entityId', paystub._entityId])] = paystub;
        this.paystubs = clone;
      }
    },
    closeEditPaystubDialog() {
      this.editPaystubDialogVm.visible = false;
      this.editPaystubDialogVm.paystub = null;
    },
    closeGenerateW2Dialog() {
      this.generateW2DialogVm.visible = false;
      this.generateW2DialogVm.client = null;
    },
    generateW2s() {
      this.generateW2DialogVm.visible = true;
    },
  },
  components: {
    ContextBarAndContent,
    EditPaystubDialog,
    PaystubTable,
    GenerateW2Dialog,
  },
};

</script>

<style lang="scss">

.w2-generator {
  h4 {
    display: flex;
    align-items: center;

    button {
      margin-left: auto;
    }
  }

  .main-section {
    width: calc(100% - 18px);
  }
}

</style>
